import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Menu.Abierto = true;
        this.Vista.Titulo = 'Ayuda';

        //this.Vista.Opciones.push(

        //    { Tipo: 'opcion', Modo: 'inicio', Icono: 'home', Titulo: 'Inicio', Subtitulo: 'Inicio del sistema', Accion: () => router.push( '/inicio' ) },


        //);


        this.Vista.AccesosDirectos.push(

            { Tipo: 'opcion', Modo: 'pedidos', Icono: 'cart-outline', Titulo: 'Gestionar ventas', Subtitulo: '' },

            { Tipo: 'opcion', Modo: 'preguntas', Icono: 'account-question-outline', Titulo: 'Preguntas', Subtitulo: 'MercadoLibre', Accion: () => router.push( '/comunicacion' ) },
            { Tipo: 'opcion', Modo: 'publicaciones', Icono: 'web', Titulo: 'Publicaciones', Subtitulo: 'MercadoLibre', Accion: () => router.push( '/mercadolibre/publicaciones' ) },

            { Tipo: 'opcion', Modo: 'articulos',  Icono: 'package-variant-closed', Titulo: 'Articulos', Subtitulo: 'Productos', Accion: () => router.push( '/productos' ) },

            { Tipo: 'opcion', Modo: 'cursos',  Icono: 'book-open-page-variant', Titulo: 'Cursos', Subtitulo: '', Accion: () => router.push( '/cursos' ) },
            { Tipo: 'opcion', Modo: 'chat',  Icono: 'forum', Titulo: 'Chat', Subtitulo: '', Accion: () => router.push( '/chat' ) },
        );
    }

    async Iniciar()
    {
        this.Vista.Modo = '';
        this.Vista.Estado = 'cargando';
        this.Vista.Titulo = 'Ayuda';
        this.Vista.Modo = 'inicio';
        this.Vista.Estado = 'iniciado';
        this.Vista.onModo.subscribe( () => this.Ejecutar() );
    }

    Ejecutar()
    {
        let idx = this.Vista.Opciones.findIndex( x => x.Modo == this.Vista.Modo );
        if ( idx != -1 )
        {
            if ( this.Vista.Opciones[idx].Accion )
            {
                this.Vista.Opciones[idx].Accion();
            }
        }
    }

    Abrir(item: any)
    {

    }
}

export const Controlador = new ControladorInterfaz();


